import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LoginPage } from '../login/login';

//@IonicPage()
@Component({
  selector: 'page-resetpwd',
  templateUrl: 'resetpwd.html',
})
export class ResetpwdPage {
  private vistor_reset : FormGroup;
  accesscode= "";
  password = "";
  cpassword = "";
  otp ="";
  passtype = "password";
  showPass = false;

  validation_messages = {
    'accesscode': [],//['', Validators.required],
    'otp': [
      { type: 'required', message: '*Please enter otp.' },
    ],
    'mnumber': [
      //{ type: 'required', message: '*Please enter mobile number.' },
      { type: 'pattern', message: '*Please enter 9 digit mobile number.' }
    ],
    'password': [
      { type: 'required', message: '*Please enter a password.' },
      { type: 'minlength', message: '*Must be minimum of 8 characters length.' },
      { type: 'maxlength', message: '*Must be maximum of 30 characters length.' },
      { type: 'pattern', message: '*Atleast one letter, one capital letter, one numeric, one special character must. Please avoid sequence of numbers, characters like 123,abc,qwerty is also not valid!' },
    ],
    'cpassword': [
      { type: 'required', message: '*Please confirm your password.' },
      //{ type: 'pattern', message: '*Please enter 10 digit mobile number.' }
    ],
      
  }


  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,  
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController, 
    public http: HttpClient,    
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    public loadingCtrl: LoadingController ,
    public global: GlobalProvider ) {
    this.vistor_reset = this.formBuilder.group({
      accesscode: [null],//['', Validators.required],
      otp: ['', Validators.required],
      password: ['', Validators.compose([
                  Validators.required,
                  Validators.minLength(8),
                  Validators.maxLength(30),
                  //Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#%-_&*])[a-zA-Z0-9!@#%-_&*]+$')
                  Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*~()_=|<>-]).{8,30}$')
                ])],
      cpassword: ['', Validators.compose([Validators.required])],
    }, {'validator': this.isMatching});

    this.accesscode = this.navParams.get('accesscode');
    console.log('acacaca = '+this.accesscode);
  }

  isMatching(group: FormGroup){

    var firstPassword = group.controls['password'].value;
    var secondPassword = group.controls['cpassword'].value;
    if((firstPassword && secondPassword) && (firstPassword != secondPassword)){
      console.log("mismatch");
      return { "pw_mismatch": true };
    } else{
      return null;
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResetpwdPage');
  }

  goback(){
    this.navCtrl.pop();
  }

  showPassword(){
    this.passtype = this.passtype === 'text' ? 'password' : 'text';
    if(this.showPass){
      this.showPass = false;
    }else{
      this.showPass = true;
    }
    
  }
  
  verifyOTP(){
    (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=true;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json'
      })
    };

    let postData = JSON.stringify({
      "resetPasswordDTO": {
        "matchingPassword": this.cpassword,
        "otpValue": this.otp,
        "password": this.password,
        "verificationCode": this.accesscode
      }
    });

    console.log('--------------');
    console.log(postData);

    
    
    this.http.post(this.global.baseUrl+"api/admin/reset-password", postData, httpOptions)
      .subscribe((data:any) => {
        console.log(data['_body']);
        console.log(data);
        console.log(data.error);
        if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 5000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
            
          }else{
            if(data.errorList.length == 0){
              let toast = this.toastCtrl.create({
                message: data.message,
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
              this.navCtrl.push(LoginPage);
            }else{
              /*let toast = this.toastCtrl.create({
                message: 'OTP sent successfully!.',
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();*/
              (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
            }
            
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        (<HTMLInputElement> document.getElementById('verifyBtn')).disabled=false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/resetpwd/resetpwd.ts